import { render, staticRenderFns } from "./EmpresaReportesLayout.vue?vue&type=template&id=6b1d23fb&scoped=true&"
import script from "./EmpresaReportesLayout.vue?vue&type=script&lang=js&"
export * from "./EmpresaReportesLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaReportesLayout.vue?vue&type=style&index=0&id=6b1d23fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d23fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
